<template>
  <div class="exam-container">
    <div class="toolbar"><strong>目录（考试分成以下{{ quesCount }}个部分）：</strong></div>
    <div class="queTypeList">
      <table>
        <tr v-for="(item,idx) in questions" :key="idx">
          <th width="40"></th>
          <td>
            <h4>{{ item.showSerialNum }}、{{ item.viewTypeName }}</h4>
            <p v-if="isShowDetail">{{ item.quesTypeDesc }}</p>
          </td>
          <td width="150">
            <a href="javascript:void(0)" class="startExam" @click="startExam(idx,0)"/>
          </td>
        </tr>
      </table>
    </div>
    <div class="bottom">
      <div class="time_tip">注意：本场考试时间为<span>{{ exerciseTime ? exerciseTime : commonInfo.contestTimeLimit }}分钟</span>。
      </div>
      <div class="button clearfix">
        <a href="javascript:void(0)" class="toPrev fl" @click="toPrev"/>
        <a href="javascript:void(0)" class="toNext fr" @click="toNext"/>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ExamStartPage',
    props: {
      isShowDetail: {
        type: Boolean,
        default: true
      },
      exerciseTime: {
        type: Number
      }
    },
    computed: {
      ...mapGetters([
        'commonInfo',
        'questions',
        'currentQuestion'
      ]),
      quesCount() {
        let list = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
        let len = Object.keys(this.questions).length
        return list[len - 1]
      }
    },
    data() {
      return {
        flag: '',
        siteCourseID: '',
        courseID: ''
      }
    },
    mounted() {
      const { flag } = this.$route.params
      this.flag = flag === 'paidExam' ? '' : flag
      const { siteCourseID, courseID } = this.$route.query
      this.siteCourseID = siteCourseID
      this.courseID = courseID
    },
    methods: {
      startExam(quesType, quesIndex) {
        this.$store.dispatch('setCurQuesType', quesType)
        this.$store.dispatch('setCurQuesIndex', quesIndex)
        this.$store.dispatch('setCurQues', this.questions[quesType].list[quesIndex])
        this.$emit('toNext', true)
      },
      toPrev() {
        const { flag } = this.$route.params
        const { chapterID } = this.$route.query
        if (chapterID) {
          this.$router.push({
            path: `/${flag}/mockExam/examChapter`,
            query: {
              siteCourseID: this.siteCourseID,
              courseID: this.courseID
            }
          })
        } else {
          this.$router.push({
            path: `/${flag}/realMockExam/step`,
            query: {
              siteCourseID: this.siteCourseID,
              courseID: this.courseID
            }
          })
        }
      },
      toNext() {
        this.$store.dispatch('setCurQuesType', 0)
        this.$store.dispatch('setCurQuesIndex', 0)
        this.$store.dispatch('setCurQues', this.questions[0].list[0])
        this.$emit('toNext', true)
      }
    }
  }
</script>
